import { ArchivePageWithData } from '@layouts/archive'

const ArchivePage = (props) => {
  return (
    <ArchivePageWithData {...props} />
  )
}

ArchivePage.getInitialProps = async ({ query }) => {
  return ({ query })
}

export default ArchivePage
